import { Navbar, NavLink, ScrollArea, Drawer } from "@mantine/core";
import { useState } from "react";
import { useMediaQuery } from '@mantine/hooks';
import { IconListNumbers, IconUsers, IconTable, IconAlignCenter, IconMessage } from "@tabler/icons-react";
import { useNavigate, useLocation } from "react-router-dom";

const AppNavbar = (props) => {
    const location = useLocation();
    const [active, setActive] = useState("Teams");
    const navigate = useNavigate();

    const isMobile = useMediaQuery('(max-width: 768px)');

    const content = (
        <>
            <NavLink label="Teams" icon={<IconUsers size="1rem" stroke={1.5} />} childrenOffset={28}>
                <ScrollArea h={350}>
                    { props.teams.map((item, index) => (
                        <NavLink
                            key={index}
                            active={index === active}
                            label={item}
                            onClick={() => {
                                setActive(index)
                                navigate(`/team/${item}`)
                                if (props.isMobile && props.setOpened) props.setOpened(false);
                            }}
                        />
                    ))}
                </ScrollArea>
            </NavLink>
            <NavLink label="Matches" icon={<IconListNumbers size="1rem" stroke={1.5} />} childrenOffset={28} active={active === "Matches" ? true : false}>
                <ScrollArea h={350}>
                    { props.matches.map((item, index) => (
                        <NavLink
                            key={index}
                            active={index + props.teams.length === active}
                            label={item}
                            onClick={() => {
                                setActive(index + props.teams.length);
                                navigate(`/match/${item}`);
                                if (props.isMobile && props.setOpened) props.setOpened(false);
                            }}
                        />
                    ))}
                </ScrollArea>
            </NavLink>
            <NavLink label="Picklist" icon={<IconAlignCenter size="1rem" stroke={1.5}/>} active={active === "Picklist" ? true : false} onClick={()=>{
                    setActive("Picklist");
                    navigate("/picklist")
                    if (props.isMobile && props.setOpened) props.setOpened(false);
                }}
            />
            <NavLink label="Ask" icon={<IconMessage size="1rem" stroke={1.5}/>} active={active === "Ask" ? true : false} onClick={()=>{
                    setActive("Ask");
                    navigate("/ask")
                    if (props.isMobile && props.setOpened) props.setOpened(false);
                }}/>
        </>
    );

    return (
        isMobile ? (
            <Drawer opened={!!props.opened} onClose={() => props.setOpened && props.setOpened(false)} padding="md" size="80%" zIndex={1000} overlayBlur={2}>
                {content}
            </Drawer>
        ) : (
            <Navbar p="md" hiddenBreakpoint="sm" hidden={!props.opened} width={{ sm: 200, lg: 250 }}>
                {content}
            </Navbar>
        )
    );
}

export default AppNavbar